/**
 * Language Switcher — dropdown locale selector for the top nav.
 *
 * Faithfully transliterated from src/components/LanguageSwitcher.tsx.
 */
import { getLocale, setLocale, getAvailableLocales } from '../i18n/index.js';

export function renderLanguageSwitcher(container) {
  const locales = getAvailableLocales();
  let open = false;

  function render() {
    const current = locales.find(l => l.code === getLocale()) || locales[0];
    container.innerHTML = `
      <div class="lang-switcher">
        <button class="lang-switcher-btn" id="lang-toggle">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
            <circle cx="12" cy="12" r="10"/>
            <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
          </svg>
          ${current.label}
        </button>
        ${open ? `
          <div class="lang-switcher-dropdown" id="lang-dropdown">
            ${locales.map(l => `
              <button class="lang-switcher-option ${l.code === current.code ? 'active' : ''}" data-locale="${l.code}">
                ${l.label}
              </button>
            `).join('')}
          </div>
        ` : ''}
      </div>
    `;

    container.querySelector('#lang-toggle')?.addEventListener('click', (e) => {
      e.stopPropagation();
      open = !open;
      render();
    });

    container.querySelectorAll('[data-locale]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.stopPropagation();
        const locale = btn.dataset.locale;
        await setLocale(locale);
        open = false;
        // Re-render the whole page to apply new translations
        window.location.reload();
      });
    });
  }

  // Close dropdown on outside click
  document.addEventListener('click', () => {
    if (open) {
      open = false;
      render();
    }
  });

  render();
}
